"use strict";

angular.module("vendor")
.component("catalogAuthorizedCustomer", {
    bindings: {
        authorizedAvailable: "<",
        catalog: "="
    },
    templateUrl: require("./catalog-authorized-customer.component.html"),
    controllerAs: "CatalogAuthorizedCustomerCtrl",
    controller: "CatalogAuthorizedCustomer"
}).controller("CatalogAuthorizedCustomer", function($scope, CatalogClone) {

    $scope.$on("requestResetListing", function($event) {
        $event.preventDefault();
        $scope.$broadcast("resetListing");
    });

    this.catalogCloneService = CatalogClone;

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-authorized-customer/catalog-authorized-customer/catalog-authorized-customer.component.js
// module id = 938
// module chunks = 0